<ng-container *ngIf="!ready">
  <mat-card appearance="outlined" class="loading-card">
    <mat-card-content class="d-flex justify-content-center align-items-center">
      <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-container *ngIf="ready">

  <!-- Formulario de pago -->
  <ng-container *ngIf="!depositSaved">
    <mat-card appearance="outlined" class="mb-3">
      <mat-toolbar color="accent">
        <span style="color: white;">Pago de cuotas - {{prestamos.entidad}}</span>
        <span class="spacer"></span>

        <button mat-raised-button (click)="closeDialog()" style="cursor:pointer;" matTooltip="Cerrar">
          <mat-icon style="color:black !important;">close</mat-icon>
          <span style="color:black !important;">Cerrar</span>
        </button>

        <button mat-raised-button style="cursor:pointer;" (click)="pay()" class="ms-1">
          <mat-icon style="color:black !important;">save</mat-icon>
          <span style="color:black !important;">{{ isEditMode ? ' Actualizar pago' : ' Pagar' }}</span>
        </button>
      </mat-toolbar>

      <mat-card-content class="mt-2">
        <div class="row">
          <!-- Fecha -->
          <div class="col-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Fecha</mat-label>
              <input matInput [matDatepicker]="Paided" [(ngModel)]="pagoCuotasPrestamos.fecha" required />
              <mat-datepicker-toggle matSuffix [for]="Paided"></mat-datepicker-toggle>
              <mat-datepicker #Paided></mat-datepicker>
              <mat-error *ngIf="invalidDate">Campo requerido</mat-error>
            </mat-form-field>
          </div>

          <!-- Concepto -->
          <div class="col-4">
            <app-input inputType="text" placeholder="Concepto" [isRequired]="true"
              [(ngModel)]="pagoCuotasPrestamos.concepto"></app-input>
          </div>

          <!-- Importe Capital -->
          <div class="col-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Importe Capital</mat-label>
              <input matInput [(ngModel)]="pagoCuotasPrestamos.importeCapital"
                (ngModelChange)="onImporteCapitalChange($event)" required numberDecimalsDirective />
              <mat-error *ngIf="invalidImporteCapital">Campo requerido</mat-error>
            </mat-form-field>
          </div>

          <!-- Intereses -->
          <div class="col-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Intereses</mat-label>
              <input matInput [(ngModel)]="pagoCuotasPrestamos.intereses" numberDecimalsDirective />
            </mat-form-field>
          </div>

          <!-- Gastos Bancarios -->
          <div class="col-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Gastos Bancarios</mat-label>
              <input matInput [(ngModel)]="pagoCuotasPrestamos.gastosBancarios" numberDecimalsDirective />
            </mat-form-field>
          </div>

          <!-- Actividad -->
          <div class="col-4">
            <app-autocomplete-select [items]="activities" [(selectedItemId)]="pagoCuotasPrestamos.activitiesUid"
              [idField]="'uid'" [displayField]="'name'" [isRequired]="true" placeholder="Actividad">
            </app-autocomplete-select>
          </div>

          <!-- Cuenta bancaria -->
          <div class="col-4">
            <app-autocomplete-select [items]="bankAccounts" [(selectedItemId)]="pagoCuotasPrestamos.bankAccountsUid"
              [idField]="'uid'" [displayFields]="['bank','iban']" [isRequired]="true" placeholder="Cuenta bancaria">
            </app-autocomplete-select>
          </div>

          <!-- Proyecto -->
          <div class="col-4" *ngIf="isProjectEnable && projects?.length > 0">
            <app-autocomplete-select [items]="projects" [(selectedItemId)]="pagoCuotasPrestamos.projectUid"
              [idField]="'id'" [displayField]="'display'" placeholder="Proyecto">
            </app-autocomplete-select>
          </div>

          <!-- Tipo de proyecto -->
          <div class="col-4" *ngIf="isProjectEnable && expenseProjectTypes?.length > 0">
            <app-autocomplete-select [items]="expenseProjectTypes"
              [(selectedItemId)]="pagoCuotasPrestamos.expenseProjectTypeUid" [idField]="'id'" [displayField]="'display'"
              placeholder="Tipo de proyecto de gasto">
            </app-autocomplete-select>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <!-- Mensaje de éxito -->
  <mat-card appearance="outlined" *ngIf="depositSaved" class="success-card">
    <mat-card-content>
      <p>Pago {{ isEditMode ? 'actualizado' : 'añadido' }} correctamente</p>
      <button mat-raised-button color="primary" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
        Cerrar
      </button>
    </mat-card-content>
  </mat-card>

  <!-- Listado -->
  <div class="row" *ngIf="list">
    <div class="col">
      <mat-card appearance="outlined" class="mt-3">
        <mat-card-title>Histórico</mat-card-title>
        <mat-card-content>
          <div class="movimiento-tarjeta-credito-listado">
            <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="false" [hasButton]="true"
              [actionsTemplate]="actionsButtons">
            </app-table>
          </div>

          <ng-template #actionsButtons let-uid="uid">
            <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
              <mat-list>
                <mat-list-item (click)="edit(uid)" style="cursor:pointer;">
                  <mat-icon style="color:black !important;" matListIcon>create</mat-icon>
                  <span style="color:black !important;">Editar</span>
                </mat-list-item>
                <mat-list-item (click)="delete(uid)" style="cursor:pointer;">
                  <mat-icon style="color:red !important;" matListIcon>warning</mat-icon>
                  <span style="color:red !important;">Borrar</span>
                </mat-list-item>
              </mat-list>
            </ng-container>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="col">
      <mat-card appearance="outlined" class="mt-3">
        <mat-card-title>Información</mat-card-title>
        <hr>
        <p>Pagado: {{paided | number:'1.2-2'}}€</p>
        <p>Pendiente: {{remaining | number:'1.2-2'}}€</p>
      </mat-card>
    </div>
  </div>

</ng-container>